import { pinTargetItems } from 'features/menu/utils/pin-target-items';

import { createMainMenuNodeFromEntry } from 'experiments/deeplinks-flow-feature/treatment/features/menu/utils/create-main-menu-node-from-entry';
import { ILocalizedMenuEntry, IMainMenuNode, PosServiceMode } from 'state/unified-menu/types';

/**
 * Ensures deeplink `targetItemIds` appear in the section list even when the
 * store menu filtered them out (unavailable). Injected nodes are built from
 * `resolveEntry` (store indexed menu or OneMenu catalog). Returns which ids
 * were injected so the UI can show unavailable chrome only for those.
 */
export function injectAndPinUnavailableSectionItems(
  sectionItems: IMainMenuNode[],
  targetItemIds: string[],
  resolveEntry: (id: string) => ILocalizedMenuEntry | undefined,
  posServiceMode: PosServiceMode = 'pickup'
): { items: IMainMenuNode[]; injectedIds: string[] } {
  if (!targetItemIds.length) {
    return { items: sectionItems, injectedIds: [] };
  }

  const presentIds = new Set(sectionItems.map(item => item.id));
  const injectedIds: string[] = [];
  const injectedNodes: IMainMenuNode[] = [];

  for (const id of targetItemIds) {
    if (!id || presentIds.has(id)) {
      continue;
    }
    const entry = resolveEntry(id);
    if (!entry) {
      continue;
    }
    injectedIds.push(id);
    presentIds.add(id);
    injectedNodes.push(createMainMenuNodeFromEntry(entry, posServiceMode));
  }

  if (!injectedNodes.length) {
    return {
      items: pinTargetItems(sectionItems, targetItemIds),
      injectedIds: [],
    };
  }

  return {
    items: pinTargetItems([...injectedNodes, ...sectionItems], targetItemIds),
    injectedIds,
  };
}
